/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsUpdate } from "../../funcs/llmPromptsUpdate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdatePromptRequest$inboundSchema,
};

export const tool$llmPromptsUpdate: ToolDefinition<typeof args> = {
  name: "llm-prompts-update",
  description: `Update a prompt

Updates prompt metadata. To update the template content, create a new version instead.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsUpdate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
